import { useEffect } from 'react'

function useEnvironmentSupport() {
  useEffect(() => {
    try {
      if (typeof window === 'undefined' || typeof navigator === 'undefined') {
        return // SSR
      }

      const ua = navigator.userAgent || ''

      // Core feature detection (This is the most reliable check)
      const hasFeatures =
        'fetch' in window &&
        'Promise' in window &&
        'Symbol' in window &&
        'IntersectionObserver' in window &&
        'Map' in window &&
        typeof Object.assign === 'function' &&
        typeof Array.from === 'function'

      // General check for localStorage access (catches all private modes)
      const isStorageBlocked = (() => {
        try {
          localStorage.setItem('__test__', '1')
          localStorage.removeItem('__test__')
          return false
        } catch {
          return true // Fails in any browser's private mode
        }
      })()

      // The new Function() check is removed.
      const isSupported = hasFeatures && !isStorageBlocked

      if (!isSupported) {
        console.warn('Unsupported environment detected:', { ua })
        window.location.replace('/unsupported-browser.html')
      }
    } catch (error) {
      console.error('Environment check failed:', error)
      window.location.replace('/unsupported-browser.html')
    }
  }, [])
}

export default useEnvironmentSupport
